export default {"src":"/_next/static/media/NFTBoostDark.e1bc85e8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};